/* =================================================================
   SIDEOUT — Custom Volleyball Uniforms landing page (Shopify)

   Same behaviour as the standalone page, with one difference: the
   request form lives in an iframe on litespeedmarketing.com, because
   Shopify cannot accept file uploads. This file is the parent half of
   that conversation.

   OUT to the frame:
     sideout:context {gclid, utm_*, page_url}  – attribution, so the
                                                  lead email carries the click id
     sideout:designs {designs:[...]}           – catalog picks
   IN from the frame:
     sideout:ready    – frame is up, send it the context
     sideout:height   – resize the iframe, no inner scrollbar
     sideout:scroll   – bring the form into view (errors / thanks)
     sideout:attempt  – user pressed submit
     sideout:deselect – a chip was removed inside the frame
     sideout:lead     – SUCCESS. Fire the conversion here, where the
                        gclid and the Google tag actually live.
   ================================================================= */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  /* ---------- scroll reveal ------------------------------------- */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  document.querySelectorAll('.rv').forEach(function (el, i) {
    el.style.transitionDelay = (Math.min(i % 6, 5) * 55) + 'ms';
    if (io) io.observe(el); else el.classList.add('in');
  });

  /* ---------- catalog filter ------------------------------------ */
  var tabs  = document.querySelectorAll('.tab');
  var tiles = document.querySelectorAll('.tile');
  var grid  = document.getElementById('designGrid');
  var ASSETS = grid ? grid.dataset.assetBase : '';

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
      var f = tab.dataset.filter;
      tiles.forEach(function (tile) {
        tile.classList.toggle('is-hidden', f !== 'all' && tile.dataset.tag !== f);
      });
    });
  });

  /* ---------- the form iframe ----------------------------------- */
  var host       = document.getElementById('formFrame');
  var FRAME_SRC  = host ? host.dataset.src : '';
  var FRAME_ORIG = host ? host.dataset.origin : '';
  var CONVERSION = host ? (host.dataset.conversion || '') : '';
  var CONV_VALUE = host ? parseFloat(host.dataset.convValue) : NaN;
  var CONV_CCY   = host ? (host.dataset.convCurrency || '') : '';
  var frame      = null;
  var frameReady = false;

  function trackingContext() {
    var p = new URLSearchParams(window.location.search);
    var ctx = { page_url: window.location.href.slice(0, 500) };
    ['gclid','wbraid','gbraid','msclkid','fbclid',
     'utm_source','utm_medium','utm_campaign','utm_term','utm_content'].forEach(function (k) {
      var v = p.get(k);
      if (v) ctx[k] = v;
    });
    return ctx;
  }

  function toFrame(type, data) {
    if (!frame || !frame.contentWindow) return;
    try { frame.contentWindow.postMessage({ type: type, data: data || {} }, FRAME_ORIG); }
    catch (err) { /* frame not ready */ }
  }

  function mountFrame() {
    if (!host || !FRAME_SRC) return;
    host.classList.add('is-loading');

    frame = document.createElement('iframe');
    frame.src = FRAME_SRC;
    frame.title = 'Uniform request form';
    frame.setAttribute('scrolling', 'no');
    frame.addEventListener('load', function () { host.classList.remove('is-loading'); });
    host.appendChild(frame);

    // If the frame never reports in, show a way to reach a human rather than
    // a blank rectangle. A dead form on a paid landing page is a dead campaign.
    setTimeout(function () {
      if (!frameReady) {
        host.classList.remove('is-loading');
        var fb = document.createElement('div');
        fb.className = 'frame-fallback';
        fb.innerHTML = '<p><strong>The request form did not load.</strong> ' +
          'Email <a href="mailto:hello@sideout.com">hello@sideout.com</a> with your team name, ' +
          'roster size and the designs you like, and we will pick it up from there.</p>';
        host.appendChild(fb);
        dataLayer.push({ event: 'form_frame_failed' });
      }
    }, 8000);
  }

  /* ---------- lightbox ------------------------------------------ */
  var lb       = document.getElementById('lb');
  var lbJersey = document.getElementById('lbJersey');
  var lbShorts = document.getElementById('lbShorts');
  var lbName   = document.getElementById('lbName');
  var lbBlurb  = document.getElementById('lbBlurb');
  var lbCat    = document.getElementById('lbCat');
  var lbAdd    = document.getElementById('lbAdd');
  var lbIn     = document.getElementById('lbIn');
  var current  = null;
  var opener   = null;
  var selected = [];

  function openLB(tile) {
    current = tile.dataset.name;
    var slug = tile.dataset.slug;
    lbJersey.src = ASSETS + '/designs/jersey-' + slug + '.webp';
    lbShorts.src = ASSETS + '/designs/shorts-' + slug + '.webp';
    lbJersey.alt = current + ' custom volleyball jersey, front and back';
    lbShorts.alt = current + ' matching custom volley short';
    lbName.textContent  = current;
    lbBlurb.textContent = tile.dataset.blurb;
    lbCat.textContent   = tile.dataset.cat || 'Design';
    lbAdd.textContent   = selected.indexOf(current) > -1 ? 'Already in your request' : 'Add to my request';
    if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
    if (lbIn) lbIn.focus({ preventScroll: true });
  }
  function closeLB() {
    if (lb.close) lb.close(); else lb.removeAttribute('open');
    if (opener) { opener.focus({ preventScroll: true }); opener = null; }
  }

  if (lb) {
    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () { opener = tile; openLB(tile); });
    });
    document.getElementById('lbClose').addEventListener('click', closeLB);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLB(); });
  }

  if (lbAdd) {
    lbAdd.addEventListener('click', function () {
      if (current && selected.indexOf(current) === -1) selected.push(current);
      toFrame('sideout:designs', { designs: selected });
      closeLB();
      var req = document.getElementById('request');
      if (req) req.scrollIntoView({ behavior: 'smooth', block: 'start' });
      dataLayer.push({ event: 'design_selected', design: current });
    });
  }

  /* ---------- messages from the frame --------------------------- */
  window.addEventListener('message', function (ev) {
    if (ev.origin !== FRAME_ORIG) return;
    if (!frame || ev.source !== frame.contentWindow) return;

    var m = ev.data;
    if (!m || typeof m !== 'object' || typeof m.type !== 'string') return;
    var d = m.data || {};

    switch (m.type) {
      case 'sideout:ready':
        frameReady = true;
        host.classList.remove('is-loading');
        toFrame('sideout:context', trackingContext());
        if (selected.length) toFrame('sideout:designs', { designs: selected });
        break;

      case 'sideout:height':
        var h = parseInt(d.height, 10);
        if (h > 0 && h < 20000) frame.style.height = h + 'px';
        break;

      case 'sideout:scroll':
        var target = document.getElementById('request');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        break;

      case 'sideout:attempt':
        dataLayer.push({ event: 'form_submit_attempt', form: 'uniform_request' });
        break;

      case 'sideout:deselect':
        selected = selected.filter(function (x) { return x !== d.design; });
        break;

      case 'sideout:lead':
        dataLayer.push({ event: 'generate_lead', form: 'uniform_request' });
        if (CONVERSION && typeof window.gtag === 'function') {
          var payload = { send_to: CONVERSION };
          if (!isNaN(CONV_VALUE)) payload.value = CONV_VALUE;
          if (CONV_CCY) payload.currency = CONV_CCY;
          window.gtag('event', 'conversion', payload);
        }
        break;
    }
  });

  /* ---------- CTA tracking -------------------------------------- */
  document.querySelectorAll('[data-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      dataLayer.push({ event: 'cta_click', cta: el.dataset.cta });
    });
  });

  mountFrame();
})();
